import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import sessionReducer from './sessionSlice';
import messageReducer from './messageSlice';
import automationReducer from './automationSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    sessions: sessionReducer,
    messages: messageReducer,
    automations: automationReducer,
  },
});

export default store;
